<template lang="html">
  <div>
    <div class="loader-wrap" v-if="!loaded">
      <div class="loader-content">
        <div class="loader">
          <div class="loader__item"></div>
        </div>
      </div>
    </div>

    <div class="content" v-else>
      <h1>
        Detail stránky
      </h1>

      <v-layout>
        <table class="info-table">
          <tr v-if="type !== 'add'">
            <td class="info-table__title">
              ID:
            </td>
            <td class="info-table__value">
              <v-text-field
                disabled
                class="input--small"
                outlined
                @input="errors.id = ''"
                v-model="data.id"
                :error-messages="makeError(errors.id)"
              >
              </v-text-field>
            </td>
          </tr>
          <tr v-if="data.custom || type === 'add'">
            <td class="info-table__title">
              Název:
            </td>
            <td class="info-table__value">
              <v-text-field
                class="input--small"
                outlined
                @input="errors.name = ''"
                v-model="data.name"
                :error-messages="makeError(errors.name)"
              >
              </v-text-field>
            </td>
          </tr>
          <tr v-else>
            <td class="info-table__title">
              Název:
            </td>
            <td class="info-table__value">
              <v-text-field
                class="input--small"
                outlined
                disabled
                @input="errors.name = ''"
                v-model="data.name"
                :error-messages="makeError(errors.name)"
              >
              </v-text-field>
            </td>
          </tr>
          <tr v-if="data.custom || type === 'add'">
            <td class="info-table__title">
              Slug:
            </td>
            <td class="info-table__value">
              <v-text-field
                class="input--small"
                outlined
                @input="errors.slug = ''"
                v-model="data.slug"
                :error-messages="makeError(errors.slug)"
              >
              </v-text-field>
            </td>
          </tr>
          <tr v-if="data.content_enabled || type === 'add'">
            <td class="info-table__title">
              Obsah stránky:
            </td>
            <td class="info-table__value">
              <tiptap-vuetify
                class="wysiwyg"
                v-bind:class="{ 'wysiwyg--error': errors.content }"
                @input="errors.content = ''"
                v-model="data.content"
                :extensions="extensions"
              />
              <div
                v-if="errors.content"
                class="v-messages theme--light error--text error--wysiwyg-text"
              >
                <span>{{ makeError(errors.content) }}</span>
              </div>
              <!--    <v-textarea
                                       class="input&#45;&#45;larger"
                                       outlined
                                       v-model="data.description"
                                       @input="errors.description = ''"
                                       :error-messages="makeError(errors.description)"
                               >
                               </v-textarea>-->
            </td>
          </tr>
          <tr v-if="data.custom || type === 'add'">
            <td class="info-table__title">
              Banner:
            </td>
            <td class="info-table__value info-table__value--banner">
              <div v-if="!imageUploaded">
                <div class="image image--loader">
                  <div class="loader">
                    <div class="loader__item"></div>
                    <div class="loader__text">Nahrávání</div>
                  </div>
                </div>
              </div>
              <div v-else>
                <img
                  v-if="data.image"
                  style="max-height: 300px; max-width: 300px"
                  :src="appUrl + '/images/banner/' + data.image"
                />
              </div>

              <div class="image-controls" v-if="imageUploaded">
                <v-btn
                  @click="selectCoverImage(data.id)"
                  v-if="!data.image"
                  color="primary"
                  type="submit"
                  class="button--inputs"
                >
                  Vybrat
                </v-btn>

                <v-btn
                  @click="selectCoverImage(data.id)"
                  v-if="data.image"
                  color="secondary"
                  type="submit"
                  class="button--inputs"
                >
                  Vybrat jiný
                </v-btn>
              </div>
            </td>
          </tr>
          <tr v-if="data.custom || type === 'add'">
            <td class="info-table__title">
              Alt:
            </td>
            <td class="info-table__value">
              <v-text-field
                class="input--largest"
                outlined
                v-model="data.banner_alt"
              >
              </v-text-field>
            </td>
          </tr>
          <tr v-if="data.custom || type === 'add'">
            <td class="info-table__title">
              Odkaz:
            </td>
            <td class="info-table__value">
              <v-text-field
                class="input--largest"
                outlined
                v-model="data.banner_link"
              >
              </v-text-field>
            </td>
          </tr>

          <tr v-if="data.custom || type === 'add'">
            <td class="info-table__title">
              Audioknihy:
            </td>
            <td class="info-table__value">
              <!--   <v-select
                                      :items="authors"
                                      :error-messages="makeError(errors.author_id)"
                                      v-model="data.author_id"
                                      @select="errors.author_id = ''"
                                      outlined
                                      item-value="id"
                                      item-text="name"
                                      class="input&#45;&#45;small"
                              ></v-select>-->
              <!-- <v-select
                v-model="data.audiobooks"
                :items="audiobooks"
                :menu-props="{ maxHeight: '400' }"
                multiple
                :error-messages="makeError(errors.audiobooks)"
                item-value="id"
                @select="errors.audiobooks = ''"
                item-text="name"
                outlined
                class="input--larger input--multiselect"
                persistent-hint
              ></v-select> -->
              <v-autocomplete
                v-model="data.audiobooks"
                :items="audiobooks"
                :menu-props="{ maxHeight: '400' }"
                multiple
                :error-messages="makeError(errors.audiobooks)"
                item-value="id"
                @select="errors.audiobooks = ''"
                item-text="name"
                outlined
                class="input--larger input--multiselect"
                persistent-hint
              ></v-autocomplete>
            </td>
          </tr>

          <tr v-if="data.custom || type === 'add'">
            <td class="info-table__title">
              Publikováno:
            </td>
            <td class="info-table__value">
              <v-checkbox
                class="input--smaller"
                outlined
                v-model="data.published"
                @input="errors.published = ''"
                :error-messages="makeError(errors.published)"
              >
              </v-checkbox>
            </td>
          </tr>
        </table>
      </v-layout>

      <h2>SEO</h2>
      <v-layout>
        <table class="info-table">
          <tr>
            <td class="info-table__title">
              Titulek:
            </td>
            <td class="info-table__value">
              <v-text-field
                class="input--small"
                outlined
                @input="errors.seo_title = ''"
                v-model="data.seo_title"
                :error-messages="makeError(errors.seo_title)"
              >
              </v-text-field>
            </td>
          </tr>
          <tr>
            <td class="info-table__title">
              Popis:
            </td>
            <td class="info-table__value">
              <v-textarea
                class="input--larger"
                outlined
                @input="errors.seo_meta = ''"
                v-model="data.seo_meta"
                :error-messages="makeError(errors.seo_meta)"
              >
              </v-textarea>
            </td>
          </tr>

          <!-- <tr>
                       <td class="info-table__title">
                           Klíčová slova:
                       </td>
                       <td class="info-table__value">
                           <v-text-field
                                   class="input&#45;&#45;larger"
                                   outlined
                                   @input="errors.seo_keywords = ''"
                                   v-model="data.seo_keywords"
                                   :error-messages="makeError(errors.seo_keywords)"
                           >
                           </v-text-field>
                       </td>
                   </tr>-->
        </table>
      </v-layout>
      <v-layout>
        <div class="controls-table">
          <v-btn
            color="primary"
            type="submit"
            class="button--control"
            @click="addPage()"
            v-if="type === 'add'"
          >
            Vytvořit
          </v-btn>
          <v-btn
            color="primary"
            type="submit"
            class="button--control"
            @click="editPage()"
            v-else
          >
            Uložit
          </v-btn>
          <v-btn
            color="error"
            class="button--control"
            @click="openDialogDelete()"
            v-if="type !== 'add'"
          >
            Smazat
          </v-btn>
        </div>
      </v-layout>
    </div>
    <v-dialog v-model="dialogDelete" persistent>
      <v-card>
        <v-card-title class="headline">Smazání uživatele</v-card-title>
        <v-card-text>
          Opravdu si přejete smazat stránku <strong>{{ data.name }}</strong
          >?
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="secondary"
            class="button--dialog"
            @click="closeDialogDelete()"
          >
            zrušit
          </v-btn>
          <v-btn color="error" class="button--dialog" @click="deletePage()">
            smazat
          </v-btn>
          <v-spacer></v-spacer>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import {
  TiptapVuetify,
  Heading,
  Bold,
  Italic,
  Strike,
  Underline,
  Code,
  Paragraph,
  BulletList,
  OrderedList,
  ListItem,
  Link,
  Blockquote,
  HardBreak,
  HorizontalRule,
  History,
  Image,
} from 'tiptap-vuetify';

export default {
  name: 'PagesDetail',
  components: {
    TiptapVuetify,
  },

  data() {
    return {
      appUrl: null,
      imageUploaded: true,
      dialogDelete: false,
      type: 'add',
      audiobooks: [],
      loaded: false,
      data: {},
      errors: {},
      extensions: [
        History,
        Link,
        Underline,
        Strike,
        Italic,
        ListItem,
        BulletList,
        OrderedList,
        [
          Heading,
          {
            options: {
              levels: [2, 3],
            },
          },
        ],
        Bold,
        Paragraph,
        HardBreak,
        Image,
      ],
    };
  },

  created() {
    this.fetchAudiobooks();
    this.fetchData();

    const vm = this;
    this.$root.$on('upload-banner-page-image', (id) => {
      vm.imageUploaded = false;
      vm.$forceUpdate();
    });
    this.$root.$on('uploaded-banner-page-image', (response) => {
      console.log('RESPONSE', response);
      vm.data.image = response.name;
      vm.imageUploaded = true;
      vm.$forceUpdate();
    });
  },
  computed: {
    ...mapState(['profile']),
  },
  mounted() {
    console.debug('Env', process.env);
    this.appUrl = process.env.VUE_APP_URL;
  },
  methods: {
    makeError(item) {
      if (item === 'required') {
        return 'Toto pole je povinné';
      } else if (item === 'already_used') {
        return 'Je již používaný';
      } else if (item === 'not_valid') {
        return 'Neplatný formát';
      } else if (item) {
        return 'Neznámá chyba';
      } else {
        return '';
      }
    },
    openDialogDelete() {
      this.dialogDelete = true;
    },
    closeDialogDelete() {
      this.dialogDelete = false;
    },

    selectCoverImage(id) {
      this.$root.$emit('select-banner-page-image', id);
    },
    addPage() {
      this.loaded = false;
      const request = this.data;
      this.$axios
        .post('/admin/pages/add', request)
        .then((response) => {
          this.$router.push({ name: 'Pages' });
        })
        .catch((e) => {
          this.errors = e.response.data.error_inputs;
          this.loaded = true;
        });
    },

    editPage() {
      this.loaded = false;
      const request = this.data;
      this.$axios
        .put('/admin/pages/' + this.$route.params.id + '/edit', request)
        .then((response) => {
          this.$router.push({ name: 'Pages' });
        })
        .catch((e) => {
          this.errors = e.response.data.error_inputs;
          this.loaded = true;
        });
    },
    deletePage() {
      this.loaded = false;
      this.$axios
        .delete('/admin/pages/' + this.$route.params.id + '/delete')
        .then((response) => {
          this.$router.push({ name: 'Pages' });
        })
        .catch((e) => {
          this.errors = e.response.data.error_inputs;
          this.loaded = true;
        });
    },

    fetchData() {
      if (this.$route.params.id === 'add') {
        this.type = 'add';
        this.data = {};
        this.loaded = true;
      } else {
        this.type = 'detail';
        this.$axios
          .get('/admin/pages/' + this.$route.params.id)
          .then((response) => {
            this.type = 'detail';
            this.data = response.data.page;
            this.loaded = true;
          })
          .catch((e) => {
            this.$router.push({ name: 'Pages' });
            this.loaded = true;
          });
      }
    },
    fetchAudiobooks() {
      this.$axios
        .get('/admin/audiobooks', {params: {pagination: 0, sortBy: 'name', order: 'ASC'}})
        .then((response) => {
          let audiobooks = response.data.audiobooks;
          // this.audiobooks = audiobooks;
          this.audiobooks = audiobooks.map(it => {
                let type = ' (Audiokniha)'
                if(it.is_ebook) type = ' (E-kniha)'
                if(it.is_book) type = ' (Kniha)'
                it.name += type;
                return it;
              });
          this.loaded = true;
        })
        .catch((e) => {
          this.loaded = true;
        });
    },
  },
  watch: {},
};
</script>

<style lang="scss"></style>
